import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button
} from '@material-ui/core';

export default function ConfirmDialog(props) {
  const { confirmDialog, setConfirmDialog } = props;

  return (
    <Dialog open={confirmDialog.isOpen}>
      <DialogTitle sx={{ textAlign: 'center', color: confirmDialog.color }}>
        {confirmDialog.heading}
      </DialogTitle>
      <DialogContent>
        <Typography variant="h6">{confirmDialog.title}</Typography>
        <Typography variant="subtitle2">{confirmDialog.subTitle}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          type="button"
          variant="outlined"
          sx={{ width: 100, fontSize: 11 }}
          color="success"
          onClick={confirmDialog.onConfirm}
        >
          Yes
        </Button>
        <Button
          type="button"
          variant="outlined"
          sx={{ width: 100, fontSize: 11 }}
          color="error"
          onClick={() => setConfirmDialog({ ...confirmDialog, isOpen: false })}
        >
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
}
